import { Helmet } from 'react-helmet-async';
import { SITE_BRAND, SITE_NAME, SITE_URL } from '../../config/site';

interface PageMetaProps {
  title: string;
  description: string;
  path: string;
  ogType?: string;
  structuredData?: object | object[];
}

export default function PageMeta({
  title,
  description,
  path,
  ogType = 'website',
  structuredData,
}: PageMetaProps) {
  const canonical = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
  const hasBrand = title.includes(SITE_BRAND) || title.includes(SITE_NAME);
  const fullTitle = hasBrand ? title : `${title} | ${SITE_NAME}`;
  const structuredDataItems = Array.isArray(structuredData)
    ? structuredData
    : structuredData
      ? [structuredData]
      : [];

  return (
    <Helmet
      title={title}
      titleTemplate={hasBrand ? undefined : `%s | ${SITE_NAME}`}
      defaultTitle={SITE_NAME}
    >
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {structuredDataItems.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}
